<template>
  <div class="product">
    <el-row :gutter="24" style="margin:0;">
      <el-col :span="16" :offset="4"  >
        <div class="product-head" ref='outerD1'>
         <div class="product-head-img">
          <img src="../assets/img/wxjs.png" alt="">
         </div>
         <div class="product-head-text" >
          <span></span>
          <b class="product-head-text-title" > 卫星建设 </b>
           <p class="product-head-text-p">
            基于地基测运控能力以低轨航天器运行管理、数据接收任务为主，为气象卫星、资源卫星、导航卫星等单位管理在轨航天器近 300 颗。           </p>
           <p class="product-head-text-more"> <b @click="imgClick(1)">联系我们</b> <img src="../assets/img/right-or.png" alt=""></p>
         </div>
        </div>

        <div class="product-head" ref='outerD2'>
         <div class="product-head-text product-headr-text" >
          <span></span>
          <b class="product-head-text-title product-head-text-titleC ">地面站建设 & 测运控大厅<b></b></b>
           <p class="product-head-text-p">
            依托昆仑星座为低轨航天器、运载火箭发射、以及航空器等提供数据中继、测控服务。卫星有效载荷包括微波+激光用户载荷、星地数传载荷。 星地数传载荷采用 QV 频段，具备对地 2 路高速数据传输能力。卫星配备激光通信终端、Ka 频段相控阵终端，可为 LEO 用户提供数据中继服务。Ka 通信载荷相控阵天线支持单址/多址工作模式。
          </p>
           <p class="product-head-text-more product-head-text-more-check"> <b @click="imgClick(1)">联系我们</b> <img src="../assets/img/right-or.png" alt=""></p>
         </div>
         <div class="product-head-img product-headr-img">
          <img src="../assets/img/3.1.png" alt="">
         </div>
        </div>

        <div class="product-head" ref='outerD3'>
         <div class="product-head-img">
          <img src="../assets/img/3.3.png" alt="">
         </div>
         <div class="product-head-text">
          <span></span>
          <b class="product-head-text-title">系统集成
            <b></b>  </b>
           <p class="product-head-text-p">
            自有一流技术研发团队。先后完成了包括某保密星座、装备一体化管控、航天大数据治理应用系统、低轨卫星测控软件、基于 DSL 的星座遥测遥控平台、科学实验任务规划等一系列 20 余款大型航天软件系统研发。
          </p>
           <p class="product-head-text-more"> <b @click="imgClick(1)">联系我们</b> <img src="../assets/img/right-or.png" alt=""></p>
         </div>
        </div>

        <div class="product-head" ref='outerD4'>
         <div class="product-head-text product-headr-text">
          <span></span>
          <b class="product-head-text-title product-head-text-titleC "> 星座设计&大型软件设计 <b></b></b>
           <p class="product-head-text-p">
            联合合作伙伴研发智能高速公路巡检系统。该系统可安装在多种车辆上，在车辆高速行驶时，快速、高效、准确、安全地采集高速公路网海量高清图像和高精度点云数据，包括位置、路面粗糙度、纹理、车辙、道路几何数据、GPS、道路景观、路面破损情况等，通过实时和事后处理形成高速公路多种监视产品，满足高速公路高效巡检的需求。
          </p>
           <p class="product-head-text-more product-head-text-more-check"> <b @click="imgClick(1)">联系我们</b> <img src="../assets/img/right-or.png" alt=""></p>
         </div>
         <div class="product-head-img product-headr-img">
          <img src="../assets/img/3.4.png" alt="">
         </div>
        </div>

        <div class="product-head" ref='outerD5'>
         <div class="product-head-img">
          <img src="../assets/img/666.jpeg" alt="">
         </div>
         <div class="product-head-text">
          <span></span>
          <b class="product-head-text-title">航天科普园地设计 & 课程设计
            <b></b>  </b>
           <p class="product-head-text-p">
            由资深航天科学家与业务专家组成的顶尖团队，致力于将航天智慧融入百业，提供技术指导与行业赋能，将航天级精准与高效注入您的业务流程。而我们的航天教育科普项目，旨在激发年轻一代的好奇心与创造力，可提供专属设计课程，培养未来的航天领航者，让科学的种子在孩子们心中萌芽成长。
          </p>
           <p class="product-head-text-more"> <b @click="imgClick(1)">联系我们</b> <img src="../assets/img/right-or.png" alt=""></p>
         </div>
        </div>




      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "product",
  data () {
    return {

    };
  },
  watch: {
    $route(to, from) {
        if (to,from) {
          this.setheight()
        }
      },
    },
  mounted () {

    this.setheight()


    },
  created(){

  },
  methods:{
    setheight(){
      var element=0
    if(this.$route.query.id==1){
       element = this.$refs.outerD1;
    }else if(this.$route.query.id==2){
       element = this.$refs.outerD2;
    }else if(this.$route.query.id==3){
       element = this.$refs.outerD3;
    }else if(this.$route.query.id==4){
       element = this.$refs.outerD4;
    }else if(this.$route.query.id==5){
       element = this.$refs.outerD5;
    }
      if (element) {
        setTimeout(() => {
          const rect = element.getBoundingClientRect();
        const distanceToTop = rect.top + window.scrollY; // 计算距离顶部的距离
        this.$bus.$emit("clearKeyword",distanceToTop);
        }, 500);
      }
    },
    imgClick(num){
    this.$router.push({path:'/contact',query:{id:num}})
  },
  },
  components: {

  }
};
</script>
<style lang="scss" scoped>
.product {
  .product-head{
    display: flex;
    position: relative;
    margin-top:80px;
    margin-bottom:50px;
  }
  .product-head-img{
    width:50%;
    height:400px;
    img{
      width:100%;
      height:100%;
      z-index:2;
      position: relative;
      border-radius: 100px 0 100px 0;
    }
  }
  .product-head-text{
      width:50%;
      span{
        height:40px;
        display: block;
      }
      .product-head-text-title{
        display: block;
        padding:10px 30px;
        border-radius: 0 40px 40px 0;
        background: #e0aa02;
        color:white;
        font-size:22px;
        position: relative;
        float: left;
        b{
          position: absolute;
          top:50%;
          margin-top:-12px;
          right:-40px;
          width:24px;
          height:24px;
          background:#e0aa02 ;
          border-radius: 50%;
        }
      }
      .product-head-text-titleC{
        display: block;
        margin-right:0;
        border-radius: 50px 0 0 50px;
        float: right;
        b{
          position: absolute;
          top:50%;
          margin-top:-12px;
          left:-40px;
          width:24px;
          height:24px;
          background:#e0aa02 ;
          border-radius: 50%;

        }
      }
       .product-head-text-p{
        clear: both;
        margin-left:20px;
        font-size:17px;
        color:#949494;
        padding-top:30px;
      }
      .product-head-text-more{
        position: absolute;
        width:50%;
        right:0;
        bottom:0;
        background-image: linear-gradient(to left,#e0aa02, #ffff);
        height:40px;
        bottom:0;
        margin:0;
        z-index:1;
        border-radius: 0 0 40px 0 ;
        text-align: right;
       b{
        cursor: pointer;
        margin-right:20px;
        color:white;
        font-size:16px;
        line-height: 40px;
       }
       img{
        cursor: pointer;
        width:25px;
        margin-right:40px;
        vertical-align: middle;
       }

      }
      .product-head-text-more-check{
        left:0;
        border-radius: 0 0 40px 0 ;
        background-image: linear-gradient(to right,#e0aa02, #ffff);
      }

  }
  .product-headr-text{
    b{
      margin-left:0;
      margin-right:20px;
    }
    .product-head-text-p{
      margin-left:0px;
      margin-right:20px;
    }
    .product-head-text-more{
      text-align: left;
      b{
        margin-left:40px;
      }
     border-radius: 0 0 0 40px;
    }
  }
  .product-headr-img{
    img{
      border-radius: 0 100px 0 100px;
    }
  }
}
</style>
